// extracted by mini-css-extract-plugin
export default {"collapsedLogo":"Logo_collapsedLogo__rgR5p","logo":"Logo_logo__0nx+H"};